import React, { useCallback } from "react";
import { useTransferBulkTicketByBulkTicketAdmin } from "./dataloader";
import { useCommonFeatures } from "context/commonFeatures";
import Variant from "shared/enums/Variant";
import * as Yup from "yup";
import Validation from "shared/form/Validation";
import { useCopies } from "shared/hooks/useCopies";
import { BulkTicketTransferProps } from "./types";

export enum ManageBulkTicketViewType {
  PASS_BOOK = "PASS_BOOK",
  TICKET_TRANSFER = "TICKET_TRANSFER"
}

export function useBulkTicketTransferService({
  handleTransferSuccess,
  closeHandler,
  ...props
}: BulkTicketTransferProps) {
  const { mutateAsync: transferBulkTicket } = useTransferBulkTicketByBulkTicketAdmin();
  const { initConfirmationAlert } = useCommonFeatures();
  const [viewType, setViewType] = React.useState<ManageBulkTicketViewType>(ManageBulkTicketViewType.PASS_BOOK);
  const copies = useCopies();

  const initialValues = React.useMemo(() => {
    return { toId: "", bulkTicketIds: [] };
  }, []);

  const validationSchema = React.useMemo(() => {
    return Yup.object().shape({
      toId: Validation.textFieldValidation({ required: true, copies: copies }),
      bulkTicketIds: Validation.yupIsReqArr({ required: true, copies: copies })
    });
  }, [copies]);

  const handleBulkTicketTransfer = useCallback(
    async (values: any) => {
      initConfirmationAlert({
        message: copies.get("bulk.ticket.transfer.ownership.confirmation"),
        handleConfirm: async () => {
          try {
            await transferBulkTicket({
              ...values,
              fromId: props.registrationParticipantId,
              bulkTicketIds: values.bulkTicketIds
            });
            await handleTransferSuccess();
            closeHandler();
          } catch (error) {
            console.error(error);
          }
        },
        primaryButtonVariant: Variant.ERROR,
        primaryButtonText: copies.get("bulk.ticket.transfer.ownership"),
        secondaryButtonText: copies.get("cancel")
      });
    },
    [
      copies,
      initConfirmationAlert,
      handleTransferSuccess,
      transferBulkTicket,
      closeHandler,
      props.registrationParticipantId
    ]
  );

  return {
    handleBulkTicketTransfer,
    viewType,
    setViewType,
    validationSchema,
    initialValues
  };
}

// refactor-rahil - handle use case when bulkTicketAdmins is not available - more than 1 case
